<nav aria-label="navigation custom-pagination">
  <ul class="pagination mb-0 mb-sm-0">
    <li class="page-item">
      <a
        class="page-link"
        href="javascript:void(0)"
        (click)="pageChang('1')"
        [class.disabled]="page === 1"
      >
        <i class="fa fa-angle-double-left" aria-hidden="true"></i>
      </a>
    </li>
    <li class="page-item">
      <a
        class="page-link"
        href="javascript:void(0)"
        (click)="pageChang(+page - 1)"
        [class.disabled]="page === 1"
      >
        <i class="fa fa-angle-left" aria-hidden="true"></i>
      </a>
    </li>
    <ng-container *ngIf="+totalPage <= 10">
      <li
        class="page-item"
        *ngFor="let i of counter(totalPage); let index = index"
      >
        <a
          class="page-link"
          href="javascript:void(0)"
          (click)="pageChang((index + 1).toString())"
          [ngClass]="{active: index + 1 === page}"
          >{{ index + 1 }}</a
        >
      </li>
    </ng-container>

    <ng-container *ngIf="+totalPage > 10">
      <li class="page-item" *ngIf="+page > 1">
        <a class="page-link" href="javascript:void(0)" (click)="pageChang('1')"
          >1</a
        >
      </li>

      <li class="page-item disabled" *ngIf="+page > 2">
        <span class="page-link">...</span>
      </li>

      <li
        class="page-item"
        *ngFor="let i of counter(5); let idx = index"
        [hidden]="+page + idx > +totalPage || idx >= 5"
      >
        <a
          class="page-link"
          href="javascript:void(0)"
          (click)="pageChang((+page + idx).toString())"
          [ngClass]="{active: +page + idx === +page}"
          >{{ +page + idx }}</a
        >
      </li>

      <li class="page-item disabled" *ngIf="+page + 4 < +totalPage">
        <span class="page-link">...</span>
      </li>

      <li class="page-item" *ngIf="+page + 4 < +totalPage">
        <a
          class="page-link"
          href="javascript:void(0)"
          (click)="pageChang(totalPage.toString())"
          >{{ totalPage }}</a
        >
      </li>
    </ng-container>
    <li class="page-item">
      <a
        class="page-link"
        href="javascript:void(0)"
        (click)="pageChang(+page + 1)"
        [class.disabled]="page === +page - 2"
      >
        <i class="fa fa-angle-right" aria-hidden="true"></i>
      </a>
    </li>
    <li class="page-item">
      <a
        class="page-link"
        href="javascript:void(0)"
        (click)="pageChang(totalPage.toString())"
        [class.disabled]="+page >= +totalPage"
      >
        <i class="fa fa-angle-double-right" aria-hidden="true"></i>
      </a>
    </li>
  </ul>
</nav>
